import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索内容分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            十二大内容分类，总有一款适合你。点击进入分类频道，发现更多精彩内容。
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colorMap: Record<string, string> = {
              primary: 'bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50',
              accent: 'bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50',
              secondary: 'bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50',
            };
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-background-200/70 transition-all duration-200"
              >
                <div className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg transition-all duration-200 ${colorMap[cat.color]}`}>
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-foreground-900 transition-colors duration-200">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-400">
                  {cat.count.toLocaleString()}个
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}